import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { callNative } from '@ifit/native-webview-interface';
import VerboseUI, { growlFromNativeCalls, growlToNativeCalls } from '@ifit/verbose-ui';
import Component from './components/component';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dashboard from './views/dashboard';
import 'normalize.css';
import './sass/base/base.css';

const nativeCalls = [
  ...Dashboard.nativeCalls,
  callFromNativeMiddleware
];

class App extends Component {
  static reducer = {
    ...Dashboard.reducer
  };

  static nativeCalls = nativeCalls;

  render() {
    return (
      <Router>
        <MuiThemeProvider>
          <div className="app">
            <Route exact path="/" render={ () => <Dashboard callNative={ callToNativeMiddleware }/> } />
            <VerboseUI />
          </div>
        </MuiThemeProvider>
      </Router>
    );
  }
}

export default App;

/* istanbul ignore next */
function callFromNativeMiddleware(payload) {
  growlFromNativeCalls(payload);
}

/* istanbul ignore next */
function callToNativeMiddleware(payload) {
  growlToNativeCalls(payload);
  callNative.apply(this, arguments);
}


// WEBPACK FOOTER //
// ./src/app.js